import { Action } from 'redux'
import SettingsState from './SettingsState'

export const SettingsActions = {
    GET_SETTINGS: 'GET_SETTINGS',
    SET_SETTINGS: 'SET_SETTINGS'
}

export interface SetSettingsAction extends Action {
    settings: SettingsState
}

export default SettingsActions
